// removed by extract-text-webpack-plugin
module.exports = {"taskTemplateListView":"TaskTemplateListView__taskTemplateListView__2Fhhm","overviewHeader":"TaskTemplateListView__overviewHeader__3C63m","active":"TaskTemplateListView__active__knpru","list":"TaskTemplateListView__list__3ftHj"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Pages/TaskTemplateListOverview/TaskTemplateListView/TaskTemplateListView.scss
// module id = 1937
// module chunks = 0